exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-cart.icon[data-v-22094ecf] {\n  opacity: 1;\n  color: #000;\n}\n.button-cart.icon[data-v-22094ecf]:hover, .button-cart.icon[data-v-22094ecf]:focus {\n    opacity: 0.8;\n}\n.minicart-count[data-v-22094ecf] {\n  top: 7px;\n  left: 50%;\n  min-width: 16px;\n  min-height: 16px;\n  border-radius: 10px;\n}\n.cart-icon[data-v-22094ecf] {\n  width: 20px;\n  height: 20px;\n}\n", ""]);

// exports
